/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
function handleInitialAdjustments({
  questionnaire,
  setFieldValue
}) {
  try {
   

  } catch (e) {
    console.log("Access Group User - handleInitialAdjustments error", e)
  }
}

function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    let saveFilteredQuestionnaire = false;

    if(question.idQuestion === 1970 && value?.id) {
      const updateQst = questionnaireUpdated.find(qst => qst.idQuestion === 1970);
      updateQst.answerJson = JSON.stringify(value);
      saveFilteredQuestionnaire = true;
    }
    
    if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);
  } catch (e) {
    console.log("ROLE - handleQuestionChange error", e)
  }
}

function addUser({
  questionnaire, 
  setFieldValue,
  usersGroup, 
  setUsersGroup,
  mc
}) {
  try {
    const qstUser = questionnaire.find(question => question.idQuestion === 1970);
    let { idUser, userName, personName, idPerson } = JSON.parse(qstUser.answerJson);
    const findUser = usersGroup.find(user => user.idUser === idUser);

    if (findUser) {
      if (findUser.idGroupMembership && findUser?.isExpired) {
        setUsersGroup((prev) => prev.map(grpMembership => {
          if (grpMembership.idUser === idUser) {
            grpMembership.isExpired = false
          }
          return grpMembership;
        }));
        setFieldValue(qstUser.key, '');
        return;
      }

      mc.error("Usuário ja incluso na lista.");
      return;
    }
    
    const accessRoleItem = {
      idDomain : 306,
      idUser,
      userName,
      personName,
      idPerson
    };

    setUsersGroup([...usersGroup, accessRoleItem]);
    console.log()
    setFieldValue(qstUser.key, '');
  } catch (e) {
    console.log("User - addUser error", e)
  }
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  addUser
}

export { events };